import { SAGA_ACTIONS } from '../../../_config'
import { ErrorResponse, SuccessResponse } from '../apiTypes'
import { useApiCall } from '../appApiCallHook'

type ChatToExperimentPayload = {
    [key: string]: any
}

export function useChatToExperimentApi() {
    const callApi = useApiCall()

    const createSession = <P, R>(data: ChatToExperimentPayload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.CHAT_TO_EXPERIMENT.CREATE_SESSION, data, onSuccess, onError)
    }

    const chat = <P, R>(data: ChatToExperimentPayload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.CHAT_TO_EXPERIMENT.CHAT, data, onSuccess, onError)
    }

    const listSessions = <P, R>(data: ChatToExperimentPayload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.CHAT_TO_EXPERIMENT.LIST_SESSIONS, data, onSuccess, onError)
    }

    const getSessionMessages = <P, R>(data: ChatToExperimentPayload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.CHAT_TO_EXPERIMENT.GET_SESSION_MESSAGES, data, onSuccess, onError)
    }

    const deleteSession = <P, R>(data: ChatToExperimentPayload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.CHAT_TO_EXPERIMENT.DELETE_SESSION, data, onSuccess, onError)
    }

    const chatStepsStream = <P, R>(data: ChatToExperimentPayload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.CHAT_TO_EXPERIMENT.CHAT_STEPS_STREAM, data, onSuccess, onError)
    }

    const getSupportNote = <P, R>(data: ChatToExperimentPayload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.CHAT_TO_EXPERIMENT.GET_SUPPORT_NOTE, data, onSuccess, onError)
    }

    const createFilterSession = <P, R>(data: ChatToExperimentPayload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.CHAT_TO_EXPERIMENT.CREATE_FILTER_SESSION, data, onSuccess, onError)
    }

    const filterChat = <P, R>(data: ChatToExperimentPayload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.CHAT_TO_EXPERIMENT.FILTER_CHAT, data, onSuccess, onError)
    }

    // Own action (takeEvery) so loading a filter chat never cancels, or is cancelled by, the main widget's history load.
    const getFilterSessionMessages = <P, R>(data: ChatToExperimentPayload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.CHAT_TO_EXPERIMENT.FILTER_GET_SESSION_MESSAGES, data, onSuccess, onError)
    }

    return {
        createSession,
        chat,
        listSessions,
        getSessionMessages,
        deleteSession,
        chatStepsStream,
        getSupportNote,
        createFilterSession,
        filterChat,
        getFilterSessionMessages,
    }
}
